import { Persistor } from 'redux-persist';

let registered: Persistor | undefined;

export const registerPersistor = (persistor: Persistor): void => {
    registered = persistor;
};

/** Writes the state to sessionStorage now — a navigation right after a change would outrun redux-persist's own write. */
export const flushPersistedState = async (): Promise<void> => {
    await registered?.flush();
};
